<template>
    <div class="page-wrapper">
        <div class="page-container">
            <PageHeader :title="config.pageTitle" @back="goBack" />

            <div class="content-area">
                <!-- 基本信息卡片 -->
                <PrescriptionCard title="基本信息">
                    <div class="info-grid" v-if="consultInfo.contact">
                        <div class="info-item" v-if="consultInfo.contact.name">
                            <span class="info-label">姓名：</span>
                            <span class="info-value">{{ consultInfo.contact.name }}</span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.sex">
                            <span class="info-label">性别：</span>
                            <span class="info-value">{{ consultInfo.contact.sex == '1' ? '男' : '女' }}</span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.phoneNo">
                            <span class="info-label">电话：</span>
                            <span class="info-value">{{ consultInfo.contact.phoneNo }}</span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.birthday">
                            <span class="info-label">出生日期：</span>
                            <span class="info-value">{{ consultInfo.contact.birthday }}
                                <span v-if="shouldShowTime(consultInfo.contact.birthHour, consultInfo.contact.birthMinute)">
                                    {{ formatTimeValue(consultInfo.contact.birthHour) }}:{{ formatTimeValue(consultInfo.contact.birthMinute) }}
                                </span>
                            </span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.liveArea">
                            <span class="info-label">常住地址：</span>
                            <span class="info-value">{{ consultInfo.contact.liveArea }}</span>
                        </div>
                        <div class="info-item" v-if="consultInfo.contact.birthArea">
                            <span class="info-label">出生地址：</span>
                            <span class="info-value">{{ consultInfo.contact.birthArea }}</span>
                        </div>
                    </div>
                </PrescriptionCard>

                <!-- 处方使用信息卡片 -->
                <PrescriptionCard :title="effectiveUseInfoTitle">
                    <div class="info-grid" v-if="hasUseInfo">
                        <div class="info-item" v-if="consultInfo.useDate">
                            <span class="info-label">{{ isChaoweiFlow ? '开始调理时间' : '开始服药时间' }}：</span>
                            <span class="info-value">{{ consultInfo.useDate }}</span>
                        </div>
                        <div class="info-item" v-if="config.showGanZhiLabel && consultInfo.illDay">
                            <span class="info-label">{{ isChaoweiFlow ? '状况开始时间' : '开始发病时间' }}：</span>
                            <span class="info-value">{{ consultInfo.illDay }}</span>
                        </div>
                        <div class="info-item" v-if="useDaysValue">
                            <span class="info-label">{{ useDaysLabel }}：</span>
                            <span class="info-value">{{ useDaysValue }}</span>
                        </div>
                    </div>
                    <div v-else class="text-muted">{{ isChaoweiFlow ? '暂无调理信息' : '暂无用药信息' }}</div>
                </PrescriptionCard>

                <!-- 症状信息卡片（条件渲染） -->
                <PrescriptionCard v-if="config.showSymptoms && hasSymptomData" :title="effectiveSymptomsTitle">
                    <div class="symptom-list">
                        <!-- 基本情况/脉象 -->
                        <div class="symptom-group" v-if="basicTableArray.length > 0">
                            <div class="symptom-group-title">{{ effectiveBasicGroupTitle }}</div>
                            <div class="info-grid">
                                <div class="info-item" v-for="item in basicTableArray" :key="item.key">
                                    <span class="info-label">{{ isChaoweiFlow && item.key === '主诉' ? '问询结果' : item.key }}：</span>
                                    <span class="info-value">{{ formatValue(item.value) }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 三焦辨证 -->
                        <template v-if="shangjiaoTableArray.length > 0 || zhongjiaoTableArray.length > 0 || xiajiaoTableArray.length > 0">
                            <div class="divider"></div>
                            <div class="symptom-group">
                                <div class="symptom-group-title">{{ isChaoweiFlow ? '三焦情况' : '三焦辨证' }}</div>
                                <div class="sanjiao-list">
                                    <div class="sanjiao-group" v-if="shangjiaoTableArray.length > 0">
                                        <div class="sanjiao-group-title">上焦</div>
                                        <div class="info-grid">
                                            <div class="info-item" v-for="item in shangjiaoTableArray" :key="item.key">
                                                <span class="info-label">{{ item.key }}：</span>
                                                <span class="info-value">{{ formatValue(item.value) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sanjiao-group" v-if="zhongjiaoTableArray.length > 0">
                                        <div class="sanjiao-group-title">中焦</div>
                                        <div class="info-grid">
                                            <div class="info-item" v-for="item in zhongjiaoTableArray" :key="item.key">
                                                <span class="info-label">{{ item.key }}：</span>
                                                <span class="info-value">{{ formatValue(item.value) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sanjiao-group" v-if="xiajiaoTableArray.length > 0">
                                        <div class="sanjiao-group-title">下焦</div>
                                        <div class="info-grid">
                                            <div class="info-item" v-for="item in xiajiaoTableArray" :key="item.key">
                                                <span class="info-label">{{ item.key }}：</span>
                                                <span class="info-value">{{ formatValue(item.value) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </PrescriptionCard>

                <!-- 支付信息卡片 -->
                <PrescriptionCard title="支付信息">
                    <div class="pay-area">
                        <div class="pay-amount-row">
                            <span class="pay-text">支付金额：</span>
                            <span class="pay-amount">{{ payType.value == '公共账户' && freeFlag == 'Y' ? 0 : price }}</span>
                            <span class="pay-unit">元</span>
                        </div>
                        <el-form label-width="120px" label-position="right" class="pay-form">
                            <WJTRadio v-model="payType.value" :label="payType.key + '：'" :must="payType.must" :radios="payType.options"></WJTRadio>
                        </el-form>
                    </div>
                </PrescriptionCard>

                <!-- 按钮区 -->
                <div class="btn-area">
                    <el-button class="btn-submit" type="primary" @click="pay(false)" :loading="payLoading">确认支付</el-button>
                    <el-button class="btn-back" @click="goBack">返回修改</el-button>

                </div>
            </div>
        </div>

        <!-- 微信支付二维码弹窗 -->
        <el-dialog title="微信支付" :visible.sync="qrcodeVisble" width="360px" :close-on-click-modal="dialogClosable" append-to-body>
            <div class="dialog-wrapper">
                <div id="qrcode"></div>
                <span class="qrcode-dialog-text">二维码过期了？<b @click="qrcodeRefresh">立即刷新</b></span>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PrescriptionCard from './PrescriptionCard.vue'
import PageHeader from '@/components/widgets/PageHeader.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
import QRCode from 'qrcodejs2'

export default {
    name: 'PrescriptionResultPage',
    components: {
        PrescriptionCard,
        PageHeader,
        WJTRadio,
        QRCode,
    },
    props: {
        config: {
            type: Object,
            default: () => ({
                pageTitle: '信息确认',
                showSymptoms: false,
                showGanZhiLabel: false,
                priceApi: '/api/health/v1/price',
                redirectRoute: '/Prescription',
            }),
        },
    },
    data() {
        return {
            consultInfo: {},
            payType: {
                key: '支付方式',
                value: '公共账户',
                options: ['公共账户', '微信支付'],
            },
            basicTableArray: [],
            shangjiaoTableArray: [],
            zhongjiaoTableArray: [],
            xiajiaoTableArray: [],
            submitData: {},
            price: 0,
            freeFlag: false,
            visitRecordId: sessionStorage.getItem('visitRecordId') || '',
            payLoading: false,
            qrcodeVisble: false,
            outTradeNo: '',
            dialogClosable: false,
        }
    },
    computed: {
        isChaoweiFlow() {
            return this.$route.path.indexOf('chaowei') !== -1
        },
        effectiveUseInfoTitle() {
            if (this.isChaoweiFlow) return '使用信息'
            return '处方使用信息'
        },
        hasUseInfo() {
            return !!(this.consultInfo.useDate || this.consultInfo.ganZhiPrescriptionHourRange)
        },
        useDaysLabel() {
            if (this.isChaoweiFlow) {
                return this.consultInfo.ganZhiPrescriptionHourRange ? '服用时段' : '调理天数'
            }
            if (!this.config.showGanZhiLabel) return '服药天数'
            return this.consultInfo.ganZhiPrescriptionHourRange ? '服用时间段' : '服药天数'
        },
        useDaysValue() {
            if (this.isChaoweiFlow) {
                return this.consultInfo.ganZhiPrescriptionHourRange || this.consultInfo.useDays
            }
            if (this.consultInfo.ganZhiPrescriptionHourRange) return this.consultInfo.ganZhiPrescriptionHourRange
            return this.consultInfo.useDays
        },
        effectiveSymptomsTitle() {
            if (this.isChaoweiFlow) return '健康问询'
            return '症状信息'
        },
        effectiveBasicGroupTitle() {
            if (this.isChaoweiFlow) return '基本情况'
            return '基本情况 / 脉象'
        },
        hasSymptomData() {
            return this.basicTableArray.length > 0 || this.shangjiaoTableArray.length > 0 || this.zhongjiaoTableArray.length > 0 || this.xiajiaoTableArray.length > 0
        },
    },
    created() {
        var userInfo = this.$store.getters.getUserInfo
        if (!this.utils.isEmptyObject(userInfo)) {
            this.payType.options = ['公共账户']
            this.payType.value = '公共账户'
        }
    },
    mounted() {
        this.initPageData()
        this.getPayAmount()
    },
    watch: {
        qrcodeVisble: function (val) {
            if (!val && this.mInterval != undefined && this.mInterval != null) {
                clearInterval(this.mInterval)
            }
        },
    },
    methods: {
        shouldShowTime(hour, minute) {
            return !(this.isEmptyValue(hour) && this.isEmptyValue(minute))
        },
        isEmptyValue(value) {
            return value === '' || value === null || value === undefined
        },
        formatTimeValue(value) {
            if (value === '-1' || value === -1 || value === '--') {
                return '--'
            }
            return value
        },
        formatValue(value) {
            if (Array.isArray(value)) {
                return value.join('，').replace(/,/g, '，')
            }
            if (typeof value === 'string') {
                return value.replace(/,/g, '，')
            }
            return value
        },
        goBack() {
            this.$router.go(-1)
        },
        // 设置页面显示需要的数据格式
        initPageData() {
            var consult = JSON.parse(sessionStorage.getItem('consultInfo'))
            if (!this.utils.isEmptyObject(consult)) {
                this.consultInfo = consult
            }
            this.basicTableArray.length = 0
            this.shangjiaoTableArray.length = 0
            this.zhongjiaoTableArray.length = 0
            this.xiajiaoTableArray.length = 0
            var submitData = JSON.parse(sessionStorage.getItem('submitData'))
            this.submitData = submitData

            var basicArray = submitData.basic_array
            if (!this.utils.isEmptyObject(basicArray)) {
                for (var i = 0; i < basicArray.length; i++) {
                    if (i == 0) {
                        this.basicTableArray.push(basicArray[i])
                    } else {
                        if (basicArray[i].value != '正常') {
                            this.basicTableArray.push(basicArray[i])
                        }
                    }
                }
            }
            var basicEnterArray = submitData.basic_enter_array
            if (!this.utils.isEmptyObject(basicEnterArray)) {
                for (var i = 0; i < basicEnterArray.length; i++) {
                    if (basicEnterArray[i].value.length > 0) {
                        this.basicTableArray.push(basicEnterArray[i])
                    }
                }
            }
            var maixiangArray = submitData.maixiang_array
            if (!this.utils.isEmptyObject(maixiangArray)) {
                for (var i = 0; i < maixiangArray.length; i++) {
                    if (maixiangArray[i].value != '正常') {
                        this.basicTableArray.push(maixiangArray[i])
                    }
                }
            }
            var shangjiaoArray = submitData.shangjiao_array
            if (!this.utils.isEmptyObject(shangjiaoArray)) {
                for (var i = 0; i < shangjiaoArray.length; i++) {
                    if (shangjiaoArray[i].value.length > 0) {
                        this.shangjiaoTableArray.push(shangjiaoArray[i])
                    }
                }
            }
            var zhongjiaoArray = submitData.zhongjiao_array
            if (!this.utils.isEmptyObject(zhongjiaoArray)) {
                for (var i = 0; i < zhongjiaoArray.length; i++) {
                    if (zhongjiaoArray[i].value.length > 0) {
                        this.zhongjiaoTableArray.push(zhongjiaoArray[i])
                    }
                }
            }
            var xiajiaoArray = submitData.xiajiao_array
            if (!this.utils.isEmptyObject(xiajiaoArray)) {
                for (var i = 0; i < xiajiaoArray.length; i++) {
                    if (xiajiaoArray[i].value.length > 0) {
                        this.xiajiaoTableArray.push(xiajiaoArray[i])
                    }
                }
            }
        },
        // 构建支付金额请求参数
        buildPayParams() {
            var newShangjiao_array = this.submitData.shangjiao_array.map((obj, index) => {
                obj.value = this.submitData.shangjiao_array[index].value.toString()
                return obj
            })
            var newZhongjiao_array = this.submitData.zhongjiao_array.map((obj, index) => {
                obj.value = this.submitData.zhongjiao_array[index].value.toString()
                return obj
            })
            var newXiajiao_array = this.submitData.xiajiao_array.map((obj, index) => {
                obj.value = this.submitData.xiajiao_array[index].value.toString()
                return obj
            })
            var newSubmitData = {
                basic_array: this.submitData.basic_array,
                basic_enter_array: this.submitData.basic_enter_array,
                maixiang_array: this.submitData.maixiang_array,
                shangjiao_array: newShangjiao_array,
                zhongjiao_array: newZhongjiao_array,
                xiajiao_array: newXiajiao_array,
            }

            var params = {
                patientId: this.consultInfo.contact.patientId,
                toDoDay: this.consultInfo.useDate,
                takeDays: this.consultInfo.useDays,
                visitRecordId: sessionStorage.getItem('visitRecordId'),
            }

            // 干支支持签模式：补充状况开始时间和干支相关参数
            if (this.config.showGanZhiLabel) {
                params.illDay = this.consultInfo.illDay
                params.ganZhiPrescriptionTimeType = this.consultInfo.ganZhiPrescriptionTimeType
                params.takeHours = this.consultInfo.ganZhiPrescriptionHourRange
                params.inquiryInfo = newSubmitData
            }
            // 订单类型透传（如超微饮品 recordType=B，未配置则默认普通调理方案）
            if (this.config.recordType) {
                params.recordType = this.config.recordType
            }
            return params
        },
        // 获取支付金额
        getPayAmount() {
            var params = this.buildPayParams()
            this.wjtHttp.post(this, this.config.priceApi, params, false, (res) => {
                var data = res.data
                if (data.code == 200) {
                    this.price = data.data.price
                    this.freeFlag = data.data.freeFlag
                    this.visitRecordId = data.data.visitRecordId
                    sessionStorage.setItem('visitRecordId', this.visitRecordId)
                } else {
                    this.$message({
                        message: data.msg && data.msg.length > 0 ? data.msg : '获取支付金额异常，请联系管理员',
                        type: 'error',
                    })
                }
            }, (err) => {
                console.error(err)
            })
        },
        pay(isRefresh) {
            var params = {
                productId: this.visitRecordId,
                orderType: 1,
                tradeType: 'NATIVE',
                payChannel: this.payType.value == '微信支付' ? '1' : '3',
            }
            if (!isRefresh) {
                this.payLoading = true
            }
            this.wjtHttp.post(this, '/api/api/pay/0.1/unifiedOrder', params, false, (res) => {
                var data = res.data
                this.payLoading = false
                if (data.code == 200) {
                    if (data.data.payChannel == 1 && !this.utils.isEmptyStr(data.data.qrcode)) {
                        this.qrcodeVisble = true
                        this.outTradeNo = data.data.outTradeNo
                        this.$nextTick(() => {
                            if (this.mQrCode != undefined && this.mQrCode != null) {
                                this.mQrCode.clear()
                                this.mQrCode.makeCode(data.data.qrcode)
                            } else {
                                this.mQrCode = new QRCode('qrcode', {
                                    text: data.data.qrcode,
                                    width: 256,
                                    height: 256,
                                    colorDark: '#000000',
                                    colorLight: '#ffffff',
                                    correctLevel: QRCode.CorrectLevel.H,
                                })
                            }
                            this.getPayStatus()
                        })
                    } else {
                        this.$message({
                            message: '支付成功',
                            type: 'success',
                        })
                        setTimeout(() => {
                            this.redirectAfterPay()
                        }, 1000)
                    }
                } else {
                    this.$message({
                        message: !this.utils.isEmptyStr(data.msg) ? data.msg : '支付异常，请联系管理员',
                        type: 'error',
                    })
                }
            }, (err) => {
                console.error(err)
                this.payLoading = false
            })
        },
        qrcodeRefresh() {
            this.pay(true)
        },
        getPayStatus() {
            if (this.mInterval != undefined && this.mInterval != null) {
                clearInterval(this.mInterval)
            }
            this.mInterval = setInterval(() => {
                var params = {
                    outTradeNo: this.outTradeNo,
                }
                this.wjtHttp.post(this, '/api/api/pay/0.1/query/place/result', params, false, (res) => {
                    var data = res.data
                    if (data.code == 200) {
                        if (data.data == 1103) {
                            this.$message({
                                message: '支付成功',
                                type: 'success',
                            })
                            this.qrcodeVisble = false
                            setTimeout(() => {
                                this.redirectAfterPay()
                            }, 1000)
                            clearInterval(this.mInterval)
                        }
                    }
                }, (err) => {
                    console.error(err)
                })
            }, 3000)
        },
        redirectAfterPay() {
            this.$router.push({
                path: this.config.redirectRoute,
                query: {
                    visitRecordId: this.visitRecordId,
                    patientId: this.consultInfo.contact.patientId,
                },
            })
        },
    },
}
</script>

<style scoped>
.page-wrapper {
    min-height: 100vh;
    background: #fbfcfa;
}

.page-container {
    max-width: 1152px;
    margin: 0 auto;
    padding: 32px 24px 80px;
}

/* 内容区域 */
.content-area {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* 信息网格 */
.info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.info-item {
    display: flex;
    align-items: center;
    border: 1px solid #edf0ec;
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 18px;
    line-height: 1.5;
}

.info-label {
    color:#1a1a1a;
    flex-shrink: 0;
    min-width: 130px;
    font-size: 18px;
}

.info-value {
    color: #1a1a1a;
    font-weight: 500;
    font-size: 18px;
    word-break: break-all;
}

.text-muted {
    color: #aaa;
    font-size: 16px;
}

/* 症状信息 */
.symptom-list {
    display: flex;
    flex-direction: column;
}

.symptom-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.symptom-group-title {
    font-size: 17px;
    font-weight: 600;
    color: #20863F;
    margin-bottom: 4px;
}

.divider {
    height: 1px;
    background: #eee;
    margin: 16px 0;
    width: 100%;
}

/* 三焦样式 */
.sanjiao-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.sanjiao-group {
    border: 1px solid #edf0ec;
    border-radius: 12px;
    padding: 16px;
}

.sanjiao-group-title {
    font-size: 17px;
    font-weight: 600;
    color: #20863F;
    margin-bottom: 12px;
}

/* 支付区域 */
.pay-area {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.pay-amount-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
    border: 1px solid #edf0ec;
    border-radius: 8px;
    padding: 14px 16px;
    background: linear-gradient(135deg, #f5faf7 0%, #ffffff 100%);
}

.pay-text {
    color: #555;
    font-size: 18px;
}

.pay-amount {
    font-size: 28px;
    font-weight: 700;
    color: #20863F;
    line-height: 1;
}

.pay-unit {
    color: #20863F;
    font-size: 18px;
    font-weight: 600;
}

.pay-form {
    width: 100%;
    padding-left: 4px;
}

/* 按钮区域 */
.btn-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding-top: 12px;
}

.btn-submit {
    width: 100%;
    max-width: 680px;
    height: 56px;
    border-radius: 12px;
    background: #20863F;
    border: none;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    box-shadow: 0 8px 20px rgba(42, 122, 75, 0.25);
    transition: all 0.2s;
}

.btn-submit:hover {
    background: #21633d;
    box-shadow: 0 12px 28px rgba(42, 122, 75, 0.35);
}

.btn-submit:active {
    background: #1a522f;
}

.btn-back {
    width: 100%;
    max-width: 680px;
    height: 56px;
    border-radius: 12px;
    background: #ffffff;
    border: 1px solid #e3e6e1;
    font-size: 18px;
    font-weight: 500;
    color: #666;
    transition: all 0.2s;
}

.btn-back:hover {
    background: #f5f5f5;
    color: #555;
}


/* 二维码弹窗 */
.dialog-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 0;
}

#qrcode {
    display: flex;
    justify-content: center;
}

#qrcode img {
    border-radius: 8px;
}

.qrcode-dialog-text {
    color: #333;
    font-size: 16px;
    margin-top: 24px;
}

.qrcode-dialog-text > b {
    color: #20863F;
    font-size: 16px;
    cursor: pointer;
}

/* Response */
@media (max-width: 768px) {
    .page-container {
        padding: 20px 16px 60px;
    }

    .content-area {
        gap: 20px;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .pay-form >>> .el-form-item__label {
        width: 100% !important;
        text-align: left;
        float: none;
        line-height: 1.4;
        padding-bottom: 4px;
        font-size: 18px !important;
    }

    .pay-form >>> .el-form-item__content {
        margin-left: 0 !important;
        width: 100%;
    }
}
</style>
